define(
	'SuiteDynamics.CategoryPageChanges.Entrypoint',
	[
		'Backbone',
		'underscore',
		'SuiteDynamics.CategoryPageChanges.PLPLifestyleImage',
		'SuiteDynamics.DescriptionImage.EntryPoint',
		'SuiteDynamics.CategoryFAQ.EntryPoint',
		'Facets.Browse.View',
		'Facets.Browse.CategoryHeading.View',
		'SC.Configuration'
	],
	function (
		Backbone,
		_,
		PLPLifestyleImage,
		SuiteDynamicsDescriptionImage,
		CategoryFAQEntryPoint,
		FacetsBrowseView,
		FacetsBrowseCategoryHeadingView,
		Configuration
	)
{
	'use strict';

	FacetsBrowseView.prototype.childViews = _.extend(FacetsBrowseView.prototype.childViews, {
		'Facets.Browse.CategoryHeading': function() {
			return new FacetsBrowseCategoryHeadingView({
				model: this.model.get('category'),
				descriptionOnly: false,
				hideDescription: true,
				showDescription:
					this.translator.cloneWithoutFacetId('category').getAllFacets().length === 0
			});
		},
		'Facets.Browse.CategoryBottom': function() {
			return new FacetsBrowseCategoryHeadingView({
				model: this.model.get('category'),
				descriptionOnly: true,
				hideDescription: false,
				showDescription: true
			});
		}
	});

	FacetsBrowseCategoryHeadingView.prototype.getPageHeading = function getPageHeading () {
		var headingOverrides = Configuration.get('plpCategoryHeadings.headingOverrides') || [];
		var fallbackHeading  = this.model.get('pageheading') || this.model.get('name');

		var facets = [];
		var facetsCount = 0;

		if (
			this.parentView &&
			this.parentView.translator &&
			_.isFunction(this.parentView.translator.getAllFacets)
		)
		{
			facets = this.parentView.translator.getAllFacets();
			facetsCount = facets.length;
		}

		if (facetsCount > 1) {
			return fallbackHeading;
		}
		if (!headingOverrides.length) {
			return fallbackHeading;
		}

		var categoryPath = '';

		if (window.Backbone && Backbone.history && _.isFunction(Backbone.history.getFragment)) {
			categoryPath = Backbone.history.getFragment();
		}
		if (!categoryPath) {
			categoryPath = this.model.get('fullurl') || '';
		}

		categoryPath = '/' +
			categoryPath
				.replace(/^\/+/, '')
				.split('?')[0]
				.toLowerCase()
				.replace(/\/$/, '');

		var matchingOverride = _.find(headingOverrides, function (override) {
			var overridePath = '/' +
				(override.categoryUrl || '')
					.replace(/^\/+/, '')
					.toLowerCase()
					.replace(/\/$/, '');
			return overridePath === categoryPath;
		});

		return (matchingOverride &&
			_.isString(matchingOverride.categoryHeading) &&
			matchingOverride.categoryHeading.trim().length &&
			matchingOverride.categoryHeading.trim()) || fallbackHeading;
	};

	FacetsBrowseCategoryHeadingView.prototype.getCategoryDescription = function getCategoryDescription () {
		var headingOverrides = Configuration.get('plpCategoryHeadings.headingOverrides') || [];
		var fallbackDescription = this.model.get('description');

		var facetsCount = 0;
		if (
			this.parentView &&
			this.parentView.translator &&
			_.isFunction(this.parentView.translator.getAllFacets)
		) {
			facetsCount = this.parentView.translator.getAllFacets().length;
		}

		if (facetsCount > 1 || !headingOverrides.length) {
			return fallbackDescription;
		}

		var categoryPath = '';
		if (window.Backbone && Backbone.history && _.isFunction(Backbone.history.getFragment)) {
			categoryPath = Backbone.history.getFragment();
		}
		if (!categoryPath) {
			categoryPath = this.model.get('fullurl') || '';
		}

		categoryPath = '/' +
			categoryPath.replace(/^\/+/, '').split('?')[0].toLowerCase().replace(/\/$/, '');

		var matchingOverride = _.find(headingOverrides, function (override) {
			var overridePath = '/' + (override.categoryUrl || '')
				.replace(/^\/+/, '').toLowerCase().replace(/\/$/, '');

			return overridePath === categoryPath;
		});

		if (
			matchingOverride &&
			_.isString(matchingOverride.categoryDescription) &&
			matchingOverride.categoryDescription.trim().length
		) {
			return matchingOverride.categoryDescription;
		}

		return fallbackDescription;
	};

	FacetsBrowseCategoryHeadingView.prototype.getContext = _.wrap(FacetsBrowseCategoryHeadingView.prototype.getContext, function(originalFn) {
		var originalContext = originalFn.apply(this, _.toArray(arguments).slice(1));

		var pageHeading = this.getPageHeading();
		var categoryDescription = this.getCategoryDescription();

		return _.extend(originalContext, {
			descriptionOnly: !!this.options.descriptionOnly,
			hideDescription: !! this.options.hideDescription,
			pageheading: pageHeading,
			description: categoryDescription
		});
	});

	return  {
		mountToApp: function(container) {
			PLPLifestyleImage.mountToApp(container);
			CategoryFAQEntryPoint.mountToApp(container);
			SuiteDynamicsDescriptionImage.mountToApp(container);
		}
	};
});
